// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wait-step .loading-indicator {
	height: 44px;
	padding: 10px 0 0 !important;
	font-size: 60px;
}
`, "",{"version":3,"sources":["webpack://./src/widgets/Survey/Steps/WaitStep.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,4BAA4B;CAC5B,eAAe;AAChB","sourcesContent":[".wait-step .loading-indicator {\n\theight: 44px;\n\tpadding: 10px 0 0 !important;\n\tfont-size: 60px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
